import React, { Component } from 'react'
import ScrollToElement from 'scroll-to-element'

import data from '../../_main_data'

class SectionMenu extends Component{
    render() {
        return (
            <nav className={`site-header ${this.props.color}-menu`}>
                <div className="container d-flex flex-md-row flex-column justify-content-between">
                    {
                        data.sections.map((section, key) => {
                            if (section.showInMenu === true && section.title) {
                                return (
                                    <button key={key} className="btn btn-link py-2 d-none d-md-inline-block" onClick={() => { ScrollToElement(`.${section.class}`) }}>{section.title}</button>
                                )
                            } else { return null }
                        })
                    }
                    </div>
            </nav>
        )
    }
}

export { SectionMenu }


// WEBPACK FOOTER //
// ./src/components/sections/SectionMenu.js